// extracted by mini-css-extract-plugin
export default {"wrapper":"home_wrapper__aJgrp","sidebar":"home_sidebar__n7Lks","container":"home_container__5wttX"};